<!-- @format -->

<resign-tag>

  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item"><h1 class="heading-01 heading_terms">退会手続き</h1></li>
    </ul>
  </div><!--/.container_breadcrumb-->
  
  <div class="contents">
    
    <section class="contents_area">
      <div class="contents_block detail">
        
        <p class="important_message margin-spacing-4_bottom" if={state.option=='pausable'}>公募案件へのエントリー、または受託中の案件がある為、退会ができません</p>
        
        <p class="text margin-spacing-5_bottom">こちらはEDILENTの退会手続きページになります。<br>下記の注意事項の内容をご確認いただき、メール認証画面へ進んでください。その後、お客様のご登録済みメールアドレス宛に認証コードが記載されたメールが届きますので、記載された認証コードをご入力ください。</p>
        
        
        <h2 class="heading-03 margin-spacing-2_bottom">退会手続きについての注意事項</h2>
        <p class="text margin-spacing-3_bottom">公募案件へのエントリー、ないしは受託中の案件がある場合は退会のお手続きをすることができません。<br>また公募案件へのエントリーや受託中の案件はなく、受託未清算の成果報酬、及び源泉処理が発生する場合は退会予約となり、退会を申請した翌年4月まで休止扱いとなります。その翌年5月になったら退会処理を行い、正式に登録情報や保存データの抹消を行います。</p>
        
        <ul class="unordered_list">
          <li class="unordered_list-item"><strong>「休止」の場合はご利用の再開が可能です。</strong>その際はメール認証等、必要手続きを行っていただきます。</li>
          <li class="unordered_list-item">退会処理を行う際は個人情報や成果等を含む案件情報など、<strong>会員情報の一切を抹消します。</strong>抹消後はデータの復旧を承ることができませんこと、予めご了承ください。</li>
          <li class="unordered_list-item"><strong>「退会予約・休止」の状態ではCROCO IDの退会もできません。</strong>源泉処理の時期が終わった後（退会申請をした翌年5月）に退会処理が完了してから、CROCO IDの退会をしてください。</li>
          <li class="unordered_list-item">公募案件へのエントリーや受託中の案件がなく、且つ成果報酬のお支払い等も発生しない場合は即時退会処理を行います。<br><span class="note">※この場合、CROCO IDの退会もすぐに行うことが可能です。</span></li>
        </ul>
        
        <div class="box_flex03 margin-spacing-5_top">
          <input type="checkbox" name="agree" id="agree" class="checkbox-input" onchange={(e)=>toggle(e)}>
          <label for="agree" class="checkbox-parts">上記の内容を確認しました</label>
        </div>

        <div class="wrap_button margin-spacing-4_top">
          <button id="code" disabled class="button button-primary button_checked" type="button" value="メール認証へ進む" onclick={(e)=>sendCode(e)}>メール認証へ進む</button>
        </div><!--/.container_button-->
        
      </div><!--/.contents_block-->
    </section><!--/.contents_area-->
    
  </div><!--/.contents-->


<script>
  import di from "dependency-injection";
  export default {
    state: {
      checked: false,
      option: ''
    },
    sendCode(e) {
      this.api.request('resign', 'send-code')
        .then(data=>{
          di.router.push('/menu/resign/confirm');
        })
        .catch(err => alert(err));
    },
    toggle(e) {
      this.state.checked = e.target.checked;
      this.$('button#code').disabled = !this.state.checked;
    },
    onBeforeMount(props, state) {
      this.api = di.createApi('menu');
      this.api.request('resign', 'fetch')
        .then(data=>this.update({option: data}));
    }
  }
</script>
</resign-tag>
